/* Copyright (C) 2013 Minted, LLC */

(function() {
  'use strict';

  var reportErrors = true;

  /**
   *  Set reportErrors to false. This is intended to fix the issue in Chrome
   *  where js stops executing and inflates the number of errors in our
   *  failure report.
   */
  window.onbeforeunload = function () {
    reportErrors = false;
  };

  /* Posts for logging whenever an error occurs */
  window.onerror = function (msg, url, line, column, error) {
    /*
     * column and error are currently only defined for chrome but are coming soon
     * in firefox.  This will not work correctly in Safari as long as it doesn't
     * support error messages from crossdomain loaded scripts.  Safari will
     * always have "msg=Script Error." with useless line number
     */
    var stack;
    if (error) {
      /*
       * this is better and will work as other browsers join the "error" party.
       * It is redundant if someone deliberately stuck the trace into the message
       * M.assert and M.required does this.
       */
      stack = printStackTrace({e: error}).join('\n');
    }
    var opts = {
      line: line,
      filename: url,
      column: column,
      stack: stack
    };

    // Sometimes onerror passes a dom element
    // that cannot be json-serialized.
    var msg_json_str;
    try {
      msg_json_str = JSON.stringify(msg);
    }
    catch(err) {
      msg_json_str = "" + msg;
    }

    // Add the 10 most recent events.
    if (typeof cu3 != "undefined") {
      opts.recentJQueryEvents = cu3.recentJQueryEvents.toString();
    }

    if (reportErrors) {
      _serverLogger.error(msg_json_str, opts);
      /* New Relic Browser Error Handler
       * https://docs.newrelic.com/docs/browser/new-relic-browser/
       * browser-agent-apis/noticing-or-logging-front-end-errors
       */
      if (typeof NREUM !== 'undefined') {
        NREUM.noticeError(error);
      }
    } else {
      console.debug('error not reported due to onbeforeunload event',
          msg_json_str, opts);
      return true;
    }

    // To help debug errors where the browser didn't initially log to console,
    // intentionally leave this return commented out, even though it'll result
    // in duplicate console messages in some cases.
    //return true;  // 'true' suppresses stacktrace output to console.
  };

})();
